import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';

import { HideButton, IHideButtonDispatchProps, IHideButtonStoreProps, IHideButtonOwnProps } from './index';
import { hideOffer, restoreOffer, EHideOfferState } from '../../store/hide_offer';
import {
  selectProductsParams,
  ERestoreEventSource,
  trackHiddenObjects,
  EHideOfferAnalyticsCategory,
} from '../../tracking/hide_offer';

function mapStateToProps(state: IState): IHideButtonStoreProps {
  const {
    hideOffer: { status },
    offerData: { isHiddenByUser },
  } = state;
  const isFetching = status === EHideOfferState.FETCHING;
  const productParams = selectProductsParams(state);

  return {
    isChecked: Boolean(isHiddenByUser),
    isFetching,
    productParams,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IHideButtonDispatchProps {
  return {
    hideOffer: () => dispatch(hideOffer()),
    restoreOffer: () => dispatch(restoreOffer(ERestoreEventSource.ICON)),
  };
}

function mergeProps(store: IHideButtonStoreProps, actions: IHideButtonDispatchProps, ownProps: IHideButtonOwnProps) {
  return {
    ...store,
    ...ownProps,
    ...actions,
    hideOffer: () => {
      trackHiddenObjects({
        action: 'Click_icon',
        category: EHideOfferAnalyticsCategory.HIDE,
        productParams: store.productParams,
      });
      if (actions.hideOffer) {
        actions.hideOffer();
      }
    },
  };
}

export const HideButtonContainer = connect<IHideButtonStoreProps, IHideButtonDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(HideButton);
